<template>
    <div id="payments">
        <div class="row">
            <div class="col-sm-12 col-md-11 col-lg-11">
                <div class="section-heading heading-left">
                    <span class="subtitle primary bold">Distribución de pagos.</span>
                    <div class="row">
                        <div class="col-lg-12 mb--20">
                            <h2 class="font-weight-100">
                                ¡Más de <span class="bold">{{ isMounted ? explicitMoneyFormat(rgStats.amount_paid_to_investors || 0, 0) : '--' }}</span> entregado a los inversionistas!
                            </h2>
                        </div>
                        <div v-if="isMounted" class="col-12 mb--20">
                            <ul class="nav nav-underline" id="myTab" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <a class="nav-link active" id="home-tab" data-bs-toggle="tab"
                                        data-bs-target="#home-tab-pane" type="button" role="tab"
                                        aria-controls="home-tab-pane" aria-selected="true">Acumulado</a>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <a class="nav-link" id="profile-tab" data-bs-toggle="tab"
                                        data-bs-target="#profile-tab-pane" type="button" role="tab"
                                        aria-controls="profile-tab-pane" aria-selected="false">Anual</a>
                                </li>
                            </ul>
                            <div class="tab-content" id="myTabContent">
                                <div class="tab-pane fade show active" id="home-tab-pane" role="tabpanel"
                                    aria-labelledby="home-tab" tabindex="0">
                                    <div id="acumulado" class="row">
                                        <div class="col-sm-12 col-md-10 col-lg-10">
                                            <div id="chart">
                                                <VueApexCharts v-if="isGraphReady" type="line" height="350" :options="chartOptions2"
                                                    :series="series2">
                                                </VueApexCharts>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="profile-tab-pane" role="tabpanel"
                                    aria-labelledby="profile-tab" tabindex="0">
                                    <div id="anual" class="row">
                                        <div class="col-sm-12 col-md-10 col-lg-10">
                                            <div id="chart">
                                                <VueApexCharts v-if="isGraphReady" type="bar" height="350" :options="chartOptions"
                                                    :series="series">
                                                </VueApexCharts>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="isMounted" class="col-12">
                            <!-- TABLA TEST -->
                            <div class="table-responsive">
                                <table class="table rg-table">
                                    <thead>
                                        <tr>
                                            <th v-for="(column, index) in columns" scope="col"
                                                :class="column.bold ? 'bold' : 'normal'">{{ column.title }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(tr, index) in data">
                                            <th>{{ tr.item1 }}</th>
                                            <td>{{ explicitMoneyFormat(tr.item8, 0) }}</td>
                                            <td>{{ explicitMoneyFormat(tr.item7, 0) }}</td>
                                            <td>{{ explicitMoneyFormat(tr.item6, 0) }}</td>
                                            <td>{{ explicitMoneyFormat(tr.item5, 0) }}</td>
                                            <td>{{ explicitMoneyFormat(tr.item4, 0) }}</td>
                                            <td>{{ explicitMoneyFormat(tr.item3, 0) }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div>
                                    <small><i>* datos contemplados al cierre de mes.</i></small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import formatHelper from "@mixins/formatHelper.js";
import VueApexCharts from 'vue-apexcharts';

const columns = [
    { title: "Distribución de pagos", bold: true },
    { title: "2025*", bold: false },
    { title: "2024*", bold: false },
    { title: "2023", bold: false },
    { title: "2022", bold: false },
    { title: "2021", bold: false },
    { title: "2020", bold: false },
]
const data = [
    {
        item1: "Amortizaciones",
        item2: 1615385,
        item3: 4846154,
        item4: 9461538,
        item5: 17076923,
        item6: 25384615,
        item7: 25384615,
    },
    {
        item1: "Intereses",
        item2: 646154,
        item3: 2019231,
        item4: 4100000,
        item5: 7684615,
        item6: 11846154,
        item7: 11846154,
    },
    {
        item1: "Total",
        item2: 2364923,
        item3: 9553385,
        item4: 23770923,
        item5: 49762000,
        item6: 88888154,
        item7: 88888154,
    }
]

export default {
    name: "Payments",
    props: ["rgStats", "isMounted"],
    mixins: [
        formatHelper
    ],
    components: {
        VueApexCharts
    },
    data: () => ({
        columns: columns,
        data: data,
        publicSiteYield: null,
        isGraphReady: false,
        series: [{
            name: 'Intereses',
            data: [0,0,0,0,0]
        },
        {
            name: 'Amortizaciones',
            data: [0,0,0,0,0]
        }],
        series2: [{
            name: 'Intereses',
            data: [0,0,0,0,0]
        },
        {
            name: 'Amortizaciones',
            data: [0,0,0,0,0]
        },
        {
            name: 'Total',
            data: [0,0,0,0,0]
        }],
        chartOptions: {
            chart: {
                type: 'bar',
                height: 350,
                stacked: true,
                toolbar: {
                    show: false
                },
                zoom: {
                    enabled: false
                }
            },
            tooltip: {
                enabled: false
            },
            colors: ["#28DE18", "#CBFF00"],
            dataLabels: {
                enabled: false,
            },
            responsive: [{
                breakpoint: 480,
                options: {
                    legend: {
                        position: 'bottom',
                        offsetX: -10,
                        offsetY: 0
                    }
                }
            }],
            plotOptions: {
                bar: {
                    horizontal: false,
                    borderRadius: 0,
                    dataLabels: {
                        total: {
                            enabled: false,
                            style: {
                                fontSize: '13px',
                                fontWeight: 900
                            }
                        }
                    }
                },
            },
            xaxis: {
                categories: ["2020", "2021", "2022", "2023", "2024", "2025"],
            },
            yaxis: {
                min: 0,
                max: 60000000,
                tickAmount: 3,
                labels: {
                    style: {
                        colors: '#3B3A3E',
                    },
                    floating: true,
                    formatter: function (val) {
                        let value = (val / 1).toFixed(0).replace(",", ".");
                        let money = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        if (money == null) return "";
                        else {
                            return "$" + money
                        }
                    }
                },
            },
            legend: {
                position: 'right',
                offsetY: 40
            },
            fill: {
                opacity: 1
            }
        },
        chartOptions2: {
            chart: {
                type: 'line',
                height: 350,
                stacked: false,
                toolbar: {
                    show: false
                },
                zoom: {
                    enabled: false
                },
                dropShadow: {
                    enabled: true,
                    color: '#000',
                    top: 18,
                    left: 7,
                    blur: 10,
                    opacity: 0.2
                },
            },
            tooltip: {
                enabled: false
            },
            grid: {
                show: true,
                borderColor: '#999FAE',
                strokeDashArray: 15,
                position: 'back',
                xaxis: {
                    lines: {
                        show: false
                    }
                },
                yaxis: {
                    lines: {
                        show: true
                    }
                },
                row: {
                    colors: undefined,
                    opacity: 0.5
                },
                column: {
                    colors: undefined,
                    opacity: 0.5
                },
                padding: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                },
            },
            colors: ["#28DE18", "#CBFF00", "#3b3a3e"],
            dataLabels: {
                enabled: true,
                offsetX: 0,
                offsetY: 0,
                textAnchor: 'middle',
                distributed: false,
                background: {
                    enabled: true,
                    foreColor: "#FFF",
                    opacity: 0.9,
                    borderWidth: 1,
                    borderColor: '#fff'
                },
                formatter: function (val) {
                    
                    let value = (val / 1000000).toFixed(0).replace(",", ".");
                    let money = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    if (money == null) return "";
                    else {
                        return money + "M";
                    }
                    
                }
            },
            responsive: [{
                breakpoint: 480,
                options: {
                    legend: {
                        position: 'bottom',
                        offsetX: -10,
                        offsetY: 0
                    }
                }
            }],
            xaxis: {
                categories: ["2019", "2020", "2021", "2022", "2023"],
            },
            yaxis: {
                labels: {
                    style: {
                        colors: '#3B3A3E',
                    },
                    floating: true,
                    formatter: function (val) {
                        let value = (val / 1).toFixed(0).replace(",", ".");
                        let money = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        if (money == null) return "";
                        else {
                            return "$" + money
                        }
                    }
                },
            },
            legend: {
                position: 'right',
                offsetY: 40
            },
            fill: {
                opacity: 1
            }
        },
    }),
    mounted() {
        this.getStats();
    },
        methods: {
        getStats() {
            if(this.isMounted){
                const rg_stats = this.rgStats;
                this.publicSiteYield = JSON.parse(rg_stats.public_site_yield);
                let index = 2;
                let chartIndex = 0;
                let total = 0;
                let totalInterest = 0;
                let totalAmort = 0;
                this.chartOptions.xaxis.categories = [];
                this.chartOptions2.xaxis.categories = [];
                this.publicSiteYield.amortization.forEach(item => {
                    this.data[0][`item${index}`] = item.sum_2;
                    this.data[1][`item${index}`] = item.sum;
                    this.data[2][`item${index}`] = item.Total;
                    

                    this.series[0].data[chartIndex] = item.sum;
                    this.series[1].data[chartIndex] = item.sum_2;
                    // Grafica acumulada
                    total += item.Total;
                    totalInterest += item.sum;
                    totalAmort += item.sum_2;
                    
                    this.series2[0].data[chartIndex] = totalInterest;
                    this.series2[1].data[chartIndex] = totalAmort;
                    this.series2[2].data[chartIndex] = total;
                    
                    index++;
                    chartIndex++;

                    this.chartOptions.xaxis.categories.push(item.balance_date.slice(0,4));
                    this.chartOptions2.xaxis.categories.push(item.balance_date.slice(0,4));
                });
                this.isGraphReady = true;
            }
        }
    }
}
</script>